import { Login } from "./Login";
import { LoginResponse } from "./LoginResponse";

export default class DoRestoreSessionUseCase {
  static async restoreSession(login: Login): Promise<LoginResponse> {
    if (!localStorage.getItem(Login.LOGGED_USER_KEY)) {
      return {
        success: false,
        errorMsg: "",
        userId: ""
      };
    }

    const response = await login.restoreSession();

    if (response.success) localStorage.setItem(Login.LOGGED_USER_KEY, response.userId);
    else localStorage.removeItem(Login.LOGGED_USER_KEY);

    return response;
  }
}
